export const iconFontAwesomeArrowsSquareArrowUpRight = (
	<i className="fa-solid fa-square-arrow-up-right"></i>
);
